import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiCorporate from "./apiCorporate";

const initialState = {
  corporate: null,
  isError: false,
  isLoading: false,
  loading: false,
  errorMessage: "",
};

// get corporate
export const getCorporate = createAsyncThunk(
  "corporate/getCorporate",
  async (id, thunkApi) => {
    try {
      const token = thunkApi.getState().auth.user.token;
      return await apiCorporate.getCorporate(token, id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkApi.rejectWithValue(message);
    }
  },
);

export const getMyCorporate = createAsyncThunk(
  "corporate/getMyCorporate",
  async (_, thunkApi) => {
    try {
      const token = thunkApi.getState().auth.user.token;
      return await apiCorporate.getMyCorporate(token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkApi.rejectWithValue(message);
    }
  },
);

export const updateExchangeRate = createAsyncThunk(
  "corporate/updateExchangeRate",
  async (data, thunkApi) => {
    try {
      const token = thunkApi.getState().auth.user.token;
      const res = await apiCorporate.updateExchangeRate(token, data);
      return res;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkApi.rejectWithValue(message);
    }
  },
);

const corporateSlice = createSlice({
  name: "corporate",
  initialState,
  reducers: {
    resetCorporate: (state) => {
      state.corporate = {};
    },
  },
  extraReducers: {
    [getCorporate.pending]: (state) => {
      state.isLoading = true;
    },
    [getCorporate.fulfilled]: (state, { payload }) => {
      state.corporate = payload.data;
      state.isLoading = false;
      state.isError = false;
    },
    [getCorporate.rejected]: (state, { payload }) => {
      state.errorMessage = payload;
      state.isLoading = false;
      state.isError = true;
    },
    [getMyCorporate.pending]: (state) => {
      state.isLoading = true;
    },
    [getMyCorporate.fulfilled]: (state, { payload }) => {
      state.corporate = payload.data;
      state.isLoading = false;
      state.isError = false;
    },
    [getMyCorporate.rejected]: (state, { payload }) => {
      state.errorMessage = payload;
      state.isLoading = false;
      state.isError = true;
    },
    [updateExchangeRate.pending]: (state) => {
      state.loading = true;
    },
    [updateExchangeRate.fulfilled]: (state, { payload }) => {
      state.corporate = payload.data;
      state.loading = false;
      state.isError = false;
    },
    [updateExchangeRate.rejected]: (state, { payload }) => {
      state.errorMessage = payload;
      state.loading = false;
      state.isError = true;
    },
  },
});

export const { resetCorporate } = corporateSlice.actions;

export default corporateSlice.reducer;
